import _ from 'lodash'
import {
    SHIPMENT_LIST_FETCHED,
    SHIPMENT_MODEL_LOADED,
    SHIPMENT_MODEL_UPDATED_BY_FORM,
    SET_NEW_SHIPMENT_MODEL,
    NEW_SHIPMENT_MODEL_HEADER_UPDATED_BY_FORM,
    NEW_SHIPMENT_MODEL_LINES_QUANTITY_UPDATED_BY_FORM,
    SHIPMENT_IS_FULFILLED,
    SHIPMENT_IS_UNFULFILLED,
    SET_RETURN_MODEL,
    RETURN_MODEL_UPDATED_BY_FORM,
    RETURN_MODEL_ADDRESS_UPDATED_BY_FORM,
    RETURN_MODEL_LINE_QUANTITY_CHANGED_BY_FORM,
    TRANSACTION_LIST_FETCHED,
    TRANSACTION_DOC_NUMBER_UPDATED,
    SET_SHIPMENT_IN_TRANSACTION_MODEL,
    SHIPMENT_INVOICE_NUMBER_UPDATED_BY_FORM,
    SHIPMENT_LINE_PRICE_UPDATED_BY_FORM,
    SHIPMENT_INVOICE_DATE_UPDATED,
    SHIPMENT_ORDER_TAX_CODE_UPDATED,
    NEW_SHIPMENT_MODEL_COMMENT_UPDATED_BY_FORM
} from './types';
import Dls from '../lib';
import {api} from '../api';

export const updateLinePricingFromForm = (shipmentLine, price) => {
    return {
        type: SHIPMENT_LINE_PRICE_UPDATED_BY_FORM,
        payload: {
            shipmentLineId: shipmentLine.id, 
            price: price
        }
    }
}

export const createReturnModel = (shipment) => {
    return {
        type: SET_RETURN_MODEL,
        payload: Dls.model.return(shipment)
    }
}

export const setDocModelInStore = (model) => {
    return {
        type: SET_SHIPMENT_IN_TRANSACTION_MODEL,
        payload: model
    }
}

export const updateInvoiceNumberInModel = (invoice_number) => {
    return {
        type: SHIPMENT_INVOICE_NUMBER_UPDATED_BY_FORM,
        payload: invoice_number
    }
}

export const updateReturnModelInStore = (field, value) => {
    return {
        type: RETURN_MODEL_UPDATED_BY_FORM,
        payload: {
            field, value
        }
    }
}

export const updateReturnModelAddressInStore = (type, field, value) => {
    return {
        type: RETURN_MODEL_ADDRESS_UPDATED_BY_FORM,
        payload: {type, field, value}
    }
}

export const updateReturnLineInStore = (rtnLine, newQty) => {
    return {
        type: RETURN_MODEL_LINE_QUANTITY_CHANGED_BY_FORM,
        payload: {rtnLine, newQty}
    }
}

export const fetchShipment = (jwt,params) => (dispatch) => {
    return api.shipment.fetch(jwt, params).then(res => {
        dispatch({
            type: SHIPMENT_LIST_FETCHED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const updateDocNumber = (jwt, id, number) => (dispatch) => {
    return api.shipment.updateDocNumber(jwt, id, number).then(res => {
        dispatch({
            type: TRANSACTION_DOC_NUMBER_UPDATED,
            payload: {id, number}
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const fetchTransactions = (jwt,params) => (dispatch) => {
    return api.shipment.fetchTransaction(jwt, params).then(res => {
        dispatch({
            type: TRANSACTION_LIST_FETCHED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const loadShipmentById = (jwt, id) => (dispatch) => {
    return api.shipment.loadModel(jwt, id).then( res => {
        dispatch({
            type: SHIPMENT_MODEL_LOADED,
            payload: res.data.data
        })
        return res;
    }).catch( err => {
        throw err
    })
}

export const updateShipmentTracking = (jwt, id, tracking_company, tracking_number) => (dispatch) => {
    return api.shipment.updateCarrier(jwt, id, {tracking_company, tracking_number});
}

export const deleteShipment = (jwt, id) => (dispatch) => {
    return api.shipment.delete(jwt, id);
}

export const fulfillShipment = (jwt, id) => (dispatch) => {
    return api.shipment.fulfill(jwt, id).then(res => {
        dispatch({
            type: SHIPMENT_IS_FULFILLED,
            payload: ''
        });
        return res;
    }).catch(err => {throw err});
}

export const unFulfillShipment = (jwt, id) => (dispatch) => {
    return api.shipment.unFulfill(jwt, id).then(res => {
        dispatch({
            type: SHIPMENT_IS_UNFULFILLED,
            payload: ''
        });
        return res;
    }).catch(err => {throw err});
}

export const updateShipmentModelInStore = (field, value) => {
    return ({
        type: SHIPMENT_MODEL_UPDATED_BY_FORM,
        payload: {
            field, value
        }
    });
}

export const setNewShipmentModel = (order) => {
    if (order.shopify_id) {
        return {
            type: SET_NEW_SHIPMENT_MODEL,
            payload: Dls.model.shipment(order.lines_view, order.warehouse_id, 
                _.isEmpty(order.bill_address) || !order.bill_to ? order.woo_billing : order.bill_address, 
                _.isEmpty(order.ship_address) || !order.ship_to ? order.woo_shipping : order.ship_address)
        }
    } else {
        if (order.woo_id && !_.isEmpty(order.woo_billing)) {
            return {
                type: SET_NEW_SHIPMENT_MODEL,
                payload: Dls.model.shipment(order.lines_view, order.warehouse_id, order.woo_billing, order.woo_shipping)
            }
        } else {
            return {
                type: SET_NEW_SHIPMENT_MODEL,
                payload: Dls.model.shipment(order.lines_view, order.warehouse_id, order.bill_address, order.ship_address)
            }
        }
    }
}

export const updateShipmentCommentInStoreByForm = (value) => {
    return {
        type: NEW_SHIPMENT_MODEL_COMMENT_UPDATED_BY_FORM,
        payload: value
    }
}

export const updateShipmentHeaderInStoreByForm = (fieldName, value) => {
    return {
        type: NEW_SHIPMENT_MODEL_HEADER_UPDATED_BY_FORM,
        payload: {fieldName, value}
    }
}

export const updateShipmentLineQtyInStoreByForm = (lineId, quantity) => {
    return {
        type: NEW_SHIPMENT_MODEL_LINES_QUANTITY_UPDATED_BY_FORM,
        payload: {lineId, quantity}
    }
}

export const createNewShipment = (jwt, shipment, orderId) => (dispatch) => {
    return api.shipment.create(jwt, shipment, orderId);
}

export const updateInvoiceDate = (date) => {
    return {
        type: SHIPMENT_INVOICE_DATE_UPDATED,
        payload: date
    }
}

export const updateTaxCode = (codeId) => {
    return {
        type:SHIPMENT_ORDER_TAX_CODE_UPDATED,
        payload: codeId
    }
}


// WEBPACK FOOTER //
// ./src/actions/shipment.js